export default "__VITE_ASSET__BnV92HrW__"